/* global axios */

import ApiClient from './ApiClient';

class ShopifyAPI extends ApiClient {
  constructor() {
    super('shopify', { accountScoped: true });
  }

  sendCatalogMessage(data) {
    return axios.post(`${this.url}/catalog_messages`, data);
  }
}

export default new ShopifyAPI();
